import PhoneInput from 'react-phone-input-2';
import styled, { css } from 'styled-components';

export const PhoneNumberInput = styled(PhoneInput)`
  .country-list {
    border-radius: 3px 3px 0px 0px !important;
    :not(.bottom) {
      bottom: 45px;
    }
  }
`;

export const Wrapper = styled.div`
  .ant-input,
  .ant-select .ant-select-selector {
    height: auto;
  }
  && {
    .phone-input-container {
      &.react-tel-input .form-control {
        &:hover,
        &:focus {
          border-color: var(--v3-primary-color);
          box-shadow: none;
        }
      }
      .flag-dropdown {
        margin: 1px;
        border-radius: 10px 0 0 10px;
        border-color: var(--v3-black-2);
        background-color: transparent;
        .selected-flag {
          border-radius: 10px 0 0 10px;
          border-color: var(--v3-black-2);
          background-color: var(--v3-black-0);
        }
        .country-list {
          background-color: var(--v3-black-0);
          .country.highlight {
            background-color: var(--v3-black-2);
          }
          .country {
            &:hover,
            &:focus {
              background-color: var(--v3-black-1);
            }
          }
        }
      }
    }
  }
`;

export const Label = styled.h3<{ $required?: boolean }>`
  margin: 0;
  color: var(--v3-text-color);
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.3px;

  & a {
    color: var(--v3-primary-color);
  }

  ${({ $required }) =>
    $required &&
    css`
      &::after {
        content: '*';
        position: relative;
        top: -3px;
        color: var(--v3-error-color);
        font-size: 14px;
        font-family: SimSun, sans-serif;
      }
    `}
`;
